import * as React from 'react';
import {
  updateViewTheoryHasAuthor,
  updateViewTheoryNotAuthor,
} from '../../shared/apis/landing-grammar';

const CALL_UPDATE_WHEN = 5000;
export const useUpdateReadingTime = (pageId) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      updateViewTheoryNotAuthor({ pageId });
    }, CALL_UPDATE_WHEN);

    return () => clearTimeout(timer);
  }, [pageId]);
};

export const useUpdateReadingTimeAuth = (pageId) => {
  React.useEffect(() => {
    const timer = setTimeout(() => {
      updateViewTheoryHasAuthor({ pageId });
    }, CALL_UPDATE_WHEN);

    return () => clearTimeout(timer);
  }, [pageId]);
};
